import m, {MithrilComponent} from '@bitstillery/mithril'
import {rich_text} from '@bitstillery/common/cms/lib/inline_markup'

import type {CmsComponentMeta} from '@bitstillery/common/cms/catalog_meta'

export const textMeta = {
    tier: 'inline',
    summary: 'Inline run of text for emphasis.',
    when_to_use:
        'Use inside a `Paragraph` or `Heading`; `variant` selects the emphasis. For a whole line that ' +
        'plays a role of its own (kicker, intro, small print) use a `Paragraph` `variant` instead.',
    example: `
    <Paragraph>Delivered <Text variant="bold">within 48 hours</Text>.</Paragraph>
    `,
    showcase: `
    <Column>
        <Paragraph>Delivered <Text variant="bold">within 48 hours</Text>, <Text variant="italic">stock permitting</Text>.</Paragraph>
        <Paragraph>Now shipping to <Text variant="highlight">18 countries</Text> <Text variant="muted">(EU only)</Text>.</Paragraph>
    </Column>
    `,
} satisfies CmsComponentMeta

export interface TextAttrs {
    /**
     * Inline emphasis treatment: `bold` · `italic` · `highlight` — tinted mark on a key phrase ·
     * `muted` — dialled down beside the surrounding copy (an aside, a unit, a caveat).
     */
    variant?: 'bold' | 'italic' | 'highlight' | 'muted'
}

/** Inline run of text for emphasis inside a `Paragraph`/`Heading` (replaces raw `<em>`/`<strong>`). */
export class Text extends MithrilComponent<TextAttrs> {
    view(vnode: m.Vnode<TextAttrs>) {
        const variant = vnode.attrs.variant
        return m('span', {className: variant ? `cms-text cms-text-${variant}` : 'cms-text'}, rich_text(vnode.children))
    }
}
